/**
 * Created by Roman on 2015-06-15.
 */


angular.module('flipto.components.common.validation')
    .directive('sameAs', function () {
        return {
            require: 'ngModel',
            link: function (scope, elem, attrs, ngModel) {
                ngModel.$parsers.unshift(validate);

                scope.$watch(attrs.sameAs, function () {
                    ngModel.$setViewValue(ngModel.$viewValue);
                });

                function validate(value) {
                    var isValid = !value || scope.$eval(attrs.sameAs) == value;
                    ngModel.$setValidity('sameAs', isValid);
                    return isValid ? value : undefined;
                }
            }
        };
    });